import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { isTouchDevice } from "@faire/web--source/common/isTouchDevice";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { MIN_WIDTH_BREAKPOINTS } from "@faire/web--source/common/media";
import { maybeSSR, onHydration } from "@faire/web--source/common/server-side-rendering/isSSR";
import { getEstimatedViewportType } from "@faire/web--source/common/user-agent/getEstimatedViewportType";
import { trackWebserverSsrViewpointMissView } from "@faire/web-api--source/events/webserver/view/ssrViewpointMiss";
import once from "lodash/once";
import { action, observable } from "mobx";
/**
 * Not compatible with React 18 SSR.
 *
 * @deprecated replace with useViewport
 */ export var ObservableWindow = function ObservableWindow() {
    "use strict";
    var _this = this;
    _class_call_check(this, ObservableWindow);
    var _getWindow, _getWindow1, _getWindow2;
    var _getWindow_innerWidth;
    this.width = maybeSSR() ? getEstimatedViewportType().width : (_getWindow_innerWidth = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.innerWidth) !== null && _getWindow_innerWidth !== void 0 ? _getWindow_innerWidth : 0;
    var _getWindow_innerHeight;
    this.height = maybeSSR() ? getEstimatedViewportType().height : (_getWindow_innerHeight = (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : _getWindow1.innerHeight) !== null && _getWindow_innerHeight !== void 0 ? _getWindow_innerHeight : 0;
    var _getWindow_scrollY;
    this.scrollY = maybeSSR() ? 0 : (_getWindow_scrollY = (_getWindow2 = getWindow()) === null || _getWindow2 === void 0 ? void 0 : _getWindow2.scrollY) !== null && _getWindow_scrollY !== void 0 ? _getWindow_scrollY : 0;
    this.lastScrolledDirection = "down";
    this.isTouchDevice = maybeSSR() ? false : isTouchDevice();
    this.isWindowFocused = true;
    this.isOnline = true;
    this.setDimensions = function(width, height) {
        if (maybeSSR()) {
            return;
        }
        _this.width = width;
        _this.height = height;
    };
    this.setScrollY = function(scrollY) {
        if (maybeSSR()) {
            return;
        }
        _this.scrollY = scrollY;
    };
    this.setlastScrolledDirection = function(scrollY) {
        if (maybeSSR()) {
            return;
        }
        if (scrollY > _this.scrollY) {
            _this.lastScrolledDirection = "down";
        } else if (scrollY < _this.scrollY) {
            _this.lastScrolledDirection = "up";
        }
    };
    this.debounceSetDimensions = debounceIfPossible(this.setDimensions, 200);
    this.debounceSetScrollY = debounceIfPossible(this.setScrollY, 10);
    this.debounceSetlastScrolledDirection = debounceIfPossible(this.setlastScrolledDirection, 10);
    this.initializeMeasurements = function() {
        var _getWindow, _getWindow1, _getWindow2;
        if (maybeSSR()) {
            return;
        }
        var _getWindow_innerWidth;
        _this.width = (_getWindow_innerWidth = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.innerWidth) !== null && _getWindow_innerWidth !== void 0 ? _getWindow_innerWidth : 0;
        var _getWindow_innerHeight;
        _this.height = (_getWindow_innerHeight = (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : _getWindow1.innerHeight) !== null && _getWindow_innerHeight !== void 0 ? _getWindow_innerHeight : 0;
        var _getWindow_scrollY;
        _this.scrollY = (_getWindow_scrollY = (_getWindow2 = getWindow()) === null || _getWindow2 === void 0 ? void 0 : _getWindow2.scrollY) !== null && _getWindow_scrollY !== void 0 ? _getWindow_scrollY : 0;
        _this.isTouchDevice = _this.isTouchDevice || isTouchDevice();
        // If the current HTML is generated from SSR, we will record
        // whether the viewpoint we used in SSR is of same type as the
        // actual one.
        if (getGlobalProperty("needsHydration", false)) {
            var viewportType = _this.width >= MIN_WIDTH_BREAKPOINTS.XXLARGE ? "xxLarge" : _this.width >= MIN_WIDTH_BREAKPOINTS.XLARGE ? "xLarge" : _this.width >= MIN_WIDTH_BREAKPOINTS.DESKTOP ? "desktop" : _this.width >= MIN_WIDTH_BREAKPOINTS.TABLET ? "tablet" : "mobile";
            if (viewportType !== getEstimatedViewportType().type) {
                trackWebserverSsrViewpointMissView(getGlobalProperty("routeProductArea", ""), getGlobalProperty("templatedPath", ""), viewportType);
            }
        }
    };
    this.initialize = once(function() {
        _this.initializeMeasurements();
        _this.listenForTouch().updateOnResize().updateOnScroll().updateOnFocus().updateIsOnline();
    });
    this.listenForTouch = function() {
        var _getWindow_addEventListener, _getWindow;
        var setTouchDevice = action(function() {
            var _getWindow;
            if (maybeSSR()) {
                onHydration(function() {
                    _this.isTouchDevice = true;
                });
            } else {
                _this.isTouchDevice = true;
            }
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener("touchstart", setTouchDevice);
        });
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_addEventListener = _getWindow.addEventListener) === null || _getWindow_addEventListener === void 0 ? void 0 : _getWindow_addEventListener.call(_getWindow, "touchstart", setTouchDevice);
        return _this;
    };
    this.updateOnResize = function() {
        var _getWindow_addEventListener, _getWindow;
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_addEventListener = _getWindow.addEventListener) === null || _getWindow_addEventListener === void 0 ? void 0 : _getWindow_addEventListener.call(_getWindow, "resize", function() {
            var _getWindow, _getWindow1;
            if (maybeSSR()) {
                return;
            }
            var _getWindow_innerWidth, _getWindow_innerHeight;
            _this.debounceSetDimensions((_getWindow_innerWidth = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.innerWidth) !== null && _getWindow_innerWidth !== void 0 ? _getWindow_innerWidth : 0, (_getWindow_innerHeight = (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : _getWindow1.innerHeight) !== null && _getWindow_innerHeight !== void 0 ? _getWindow_innerHeight : 0);
        }, false);
        return _this;
    };
    this.updateOnScroll = function() {
        var _getWindow_addEventListener, _getWindow;
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_addEventListener = _getWindow.addEventListener) === null || _getWindow_addEventListener === void 0 ? void 0 : _getWindow_addEventListener.call(_getWindow, "scroll", function() {
            var _getWindow, _getWindow1;
            if (maybeSSR()) {
                return;
            }
            var _getWindow_scrollY;
            _this.debounceSetlastScrolledDirection((_getWindow_scrollY = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.scrollY) !== null && _getWindow_scrollY !== void 0 ? _getWindow_scrollY : 0);
            var _getWindow_scrollY1;
            _this.debounceSetScrollY((_getWindow_scrollY1 = (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : _getWindow1.scrollY) !== null && _getWindow_scrollY1 !== void 0 ? _getWindow_scrollY1 : 0);
        }, false);
        return _this;
    };
    this.updateOnFocus = function() {
        var _getWindow_addEventListener, _getWindow, _getWindow_addEventListener1, _getWindow1;
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_addEventListener = _getWindow.addEventListener) === null || _getWindow_addEventListener === void 0 ? void 0 : _getWindow_addEventListener.call(_getWindow, "focus", action(function() {
            if (maybeSSR()) {
                onHydration(function() {
                    _this.isWindowFocused = true;
                });
                return;
            }
            _this.isWindowFocused = true;
        }), false);
        (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : (_getWindow_addEventListener1 = _getWindow1.addEventListener) === null || _getWindow_addEventListener1 === void 0 ? void 0 : _getWindow_addEventListener1.call(_getWindow1, "blur", action(function() {
            if (maybeSSR()) {
                onHydration(function() {
                    _this.isWindowFocused = false;
                });
                return;
            }
            _this.isWindowFocused = false;
        }), false);
        return _this;
    };
    this.updateIsOnline = function() {
        var _getWindow_addEventListener, _getWindow, _getWindow_addEventListener1, _getWindow1;
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_addEventListener = _getWindow.addEventListener) === null || _getWindow_addEventListener === void 0 ? void 0 : _getWindow_addEventListener.call(_getWindow, "online", action(function() {
            if (maybeSSR()) {
                onHydration(function() {
                    _this.isOnline = true;
                });
                return;
            }
            _this.isOnline = true;
        }), false);
        (_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : (_getWindow_addEventListener1 = _getWindow1.addEventListener) === null || _getWindow_addEventListener1 === void 0 ? void 0 : _getWindow_addEventListener1.call(_getWindow1, "offline", action(function() {
            if (maybeSSR()) {
                onHydration(function() {
                    _this.isOnline = false;
                });
                return;
            }
            _this.isOnline = false;
        }), false);
        return _this;
    };
    makeObservable(this);
    if (maybeSSR()) {
        onHydration(function() {
            _this.initializeMeasurements();
        });
    }
};
__decorate([
    observable
], ObservableWindow.prototype, "width", void 0);
__decorate([
    observable
], ObservableWindow.prototype, "height", void 0);
__decorate([
    observable
], ObservableWindow.prototype, "scrollY", void 0);
__decorate([
    observable
], ObservableWindow.prototype, "lastScrolledDirection", void 0);
__decorate([
    observable
], ObservableWindow.prototype, "isTouchDevice", void 0);
__decorate([
    observable
], ObservableWindow.prototype, "isWindowFocused", void 0);
__decorate([
    observable
], ObservableWindow.prototype, "isOnline", void 0);
__decorate([
    action
], ObservableWindow.prototype, "setDimensions", void 0);
__decorate([
    action
], ObservableWindow.prototype, "setScrollY", void 0);
__decorate([
    action
], ObservableWindow.prototype, "setlastScrolledDirection", void 0);
__decorate([
    action
], ObservableWindow.prototype, "initializeMeasurements", void 0);
